import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import Privacy from "./Privacy";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {window.location.pathname === "/privacy" ? <Privacy /> : <App />}
  </React.StrictMode>
);
